<a class="link display-inline-block" (click)="showModal()" (keydown.enter)="showModal()" (keydown.space)="showModal()" #modalLink tabindex="0">
    <span class="icon icon-warning trip-summary__status--disallowed"></span>
</a>


<ng-template #modal>
    <ridango-modal [size]="'800'" [visible]="true" (onCloseModal)="closeModal()">
        <div class="modal-dialog-800__wrapper">
            <h1>{{'MODAL_TRANSIT_INFO' | translate}}</h1>
            <div class="block-items">
                <div class="items">
                    <span class="items__title" #modalFocus tabindex="-1">
                        {{'MODAL_TRANSIT_INFO_NOTICE' | translate}}
                        <span class="icon icon-warning trip-summary__status--disallowed"></span>
                    </span>
                    <p class="items__description" *ngFor="let message of messages">
                        {{ message | translateObjectField: 'message':locale }}
                    </p>
                </div>
            </div>
        </div>
    </ridango-modal>
</ng-template>
